import React from 'react';
import CalendarTable from './calender';
import ExampleBox from './ExampleBox';

const PaymentExample = () => {
  return (
    <div className="font-sans text-gray-800 bg-white max-w-5xl mx-auto rounded-2xl">
      {/* <Header /> */}
      <MainContent />
      {/* <Footer /> */}
    </div>
  );
};

const MainContent = () => {
  return (
    <main className="px-4 py-6 sm:px-6 md:px-8 md:py-8">
      <ExamplesWithCalendar />
    </main>
  );
};

const ExamplesWithCalendar = () => {
  return (
    <div>
      <SectionTitle>Examples With Calendar</SectionTitle>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 my-8">
        {/* First Column - 2 rows with equal height distribution */}
        <div className="flex flex-col gap-5">
          <div className="flex-1">
            <ExampleBox 
              title="Weekly Net 7 Example" 
              content={
                <>
                  <div className="bg-gray-50 p-4 my-4 rounded-lg">
                    <p>Commissions earned during July 1-7 (highlighted) will be paid on July 15:</p>
                    <CalendarTable 
                      highlightDays={[1,2,3,4,5,6,7]}
                      paymentDate={15}
                      numberOfWeeks={3}
                    />
                  </div>
                </>
              }
            />
          </div>
          
          <div className="flex-1">
            <ExampleBox 
              title="Weekly Net 5 Example" 
              content={
                <>
                  <div className="bg-gray-50 p-4 my-4 rounded-lg">
                    <CalendarTable 
                      highlightDays={[1,2,3,4,5]}
                      paymentDate={8}
                      numberOfWeeks={2}
                    />
                  </div>
                </>
              }
            />
          </div>
        </div>
        
        {/* Second Column - 1 row spanning full height */}
        <div className="flex">
          <div className="flex-1">
            <ExampleBox 
              title="Monthly Net 7 Example" 
              content={
                <>
                  <p>With <span className="text-[#048998] font-semibold">Monthly Net 7</span> payment terms, all commissions for the month of July will be paid 7 days after the end of July:</p>
                  
                  <div className="bg-gray-50 p-4 my-4 rounded-lg">
                    <p>Commissions earned during all of July (highlighted) will be paid on August 7:</p>
                    <CalendarTable 
                      highlightDays={[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]}
                      paymentDate={null}
                      numberOfWeeks={5}
                    />
                    
                    <CalendarTable 
                      // isNextMonth={true}
                      paymentDate={7}
                      numberOfWeeks={3}
                    />
                  </div>
                </>
              }
            />
          </div>
        </div>
      </div>

      {/* Stacking columns for small screens */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 my-8">
        <ExampleBox 
          title="Monthly Net 15 Example" 
          content={
            <>
              <p>With <span className="text-[#048998] font-semibold">Monthly Net 15</span> payment terms, all commissions for the month of July will be paid 15 days after the end of July:</p>
              
              <div className="bg-gray-50 p-4 my-4 rounded-lg">
                <p>Commissions earned during all of July (highlighted) will be paid on August 15:</p>
                <CalendarTable 
                  highlightDays={[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]}
                  paymentDate={null}
                  numberOfWeeks={5}
                />
                
                  <CalendarTable 
                  paymentDate={15}
                  numberOfWeeks={5}
                />
              </div>
            </>
          }
        />
        <ExampleBox
          title="Monthly Net 30 Example" 
          content={
            <>
              <p>With <span className="text-[#048998] font-semibold">Monthly Net 30</span> payment terms, all commissions for the month of July will be paid 30 days after the end of July:</p>
              
              <div className="bg-gray-50 p-4 my-4 rounded-lg">
                <p>Commissions earned during all of July (highlighted) will be paid on August 30:</p>
                <CalendarTable 
                  highlightDays={[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]}
                  paymentDate={null}
                  numberOfWeeks={5}
                />
                
                
                  <CalendarTable
                  paymentDate={30}
                  numberOfWeeks={5}
                />
              </div>
            </>
          }
        />
      </div>
      {/* Stacking columns for small screens */}
      <div className="grid grid-cols-1 my-8">
        <ExampleBox 
          title="Bi-Weekly Or Net 15 Example" 
          content={
            <>
              <p>With <span className="text-[#048998] font-semibold">Monthly Net 15</span> payment terms, all commissions for the month of July will be paid 15 days after the end of July:</p>
              
              <div className="bg-gray-50 p-4 my-4 rounded-lg">
                <p>Commissions earned during all of July (highlighted) will be paid on August 15:</p>
                <CalendarTable 
                  highlightDays={[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]}
                  paymentDate={31}
                  numberOfWeeks={5}
                />
                
              </div>
            </>
          }
        />
      </div>
    </div>
  );
};

// Reusable Components
const SectionTitle = ({ children }) => {
  return (
    <h2 className="text-2xl font-semibold mt-10 mb-5 text-[#048998] pb-2 border-b-2 border-[#048998]/10">
      {children}
    </h2>
  );
};

export default PaymentExample;